<template>
    <div class="table-responsive">
        <table>
            <thead>
                <tr>
                    <th>{{ sts_type === 'POR'?$t('message.porcentaje'):$t('message.area') }}</th>
                    <th>{{ $t('message.valor') }}</th>
                    <th>H.M</th>
                    <th>
                        <button @click="agregar" class="btn-success" type="button"><i class="fa fa-plus"></i></button>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr @eliminar="eliminar" v-for="(area, index) in areas" is="tr-area" :key="moment(new Date()).format('YYYYMMDDHHmmss') + index" v-model="areas[index]"></tr>
                <tr v-show="areas.length === 0">
                    <td colspan="4">
                        <strong>{{ $t('message.sinDatos') }}</strong>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props : {
        sts_type : {
            required : false,
            default : 'PAR',
            type : String
        },
        value : {
            required : false,
            default : function () {
                return [];
            }
        }
    },
    data : function () {
        return {
            areas : this.value,
            moment : moment
        };
    },
    methods : {
        eliminar : function (index) {
            this.areas.splice(index, 1);
        },
        agregar : function () {
            this.areas.push({
                area : 0,
                valor : 0,
                hora_trabajo : 0
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/sts/TablaAreas.vue